import { Component, EventEmitter, Output } from '@angular/core';
import { Constants } from '@base/src/app/models/constants';
import { QRButton } from '@base/src/app/models/qr-button.model';
import { QRIcon } from '@base/src/app/models/qr-icon.model';
import { DialogEvent } from '@base/src/app/models/dialog-event.model';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-rendition-finish-movements',
  templateUrl: './rendition-finish-movements.component.html',
  styleUrls: ['./rendition-finish-movements.component.scss'],
})
export class RenditionFinishMovementsComponent {
  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  @Output() dialogChange: EventEmitter<DialogEvent> =
    new EventEmitter<DialogEvent>();
  value: string | undefined;

  buttonGoPanel: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Ir al listado',
  };

  buttonGoGestor: QRButton = {
    hierarchy: QRButton.HIERARCHY_2,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Volver al gestor',
  };

  buttonPrint: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Imprimir',
    icon: Constants.ICONS.PRINT,
  };

  readonly ICON_DONE = Constants.ICONS.CHECK_2;
  readonly ICON_COLOR_WHITE = QRIcon.COLOR_WHITE;

  isFromGestor = false;

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.isFromGestor =
      this.activatedRoute.snapshot.queryParams['origin'] === 'gestor';
  }

  onAction(type: number) {
    const action = type == 0 ? 'imprimir' : 'panel';
    this.change.emit({ action: action });
  }

  goGestor() {
    this.router.navigate(['/gestor']);
  }
}
